import { ref } from 'vue'
import mediaUploadService from '../services/mediaUploadService'

/**
 * Shared background library loader/uploader for AvatarChat components and testing page.
 * Returns reactive list of background options and helpers.
 * Each option shape: { id, label, src, kind: 'background' }
 */
// Singleton reactive state so all callers share the same list
const options = ref([])
const loading = ref(false)
const error = ref('')

export function useBackgroundLibrary() {
  const load = async () => {
    loading.value = true
    error.value = ''
    try {
      const records = await mediaUploadService.listBackgrounds()
      options.value = (records || []).map((r) => mediaUploadService.toOption(r))
    } catch (e) {
      error.value = e?.message || 'Failed to load backgrounds'
      options.value = []
    } finally {
      loading.value = false
    }
  }

  const upload = async (file, metadata = {}) => {
    const record = await mediaUploadService.uploadBackground({ file, metadata })
    const opt = mediaUploadService.toOption(record)
    options.value = [opt, ...options.value]
    return opt
  }

  const getById = (id) => options.value.find((o) => o.id === id) || null

  const remove = async (id) => {
    if (!id) return false
    const ok = await mediaUploadService.deleteBackground(id)
    if (ok) {
      options.value = options.value.filter((o) => o.id !== id)
    }
    return ok
  }

  return { options, loading, error, load, upload, getById, remove }
}
